<template>
  <ZMainPage :loading="loading" type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">基础信息</span>
      </div>
      <LineWrapper column="3" label-width="170rem" list>
        <LineItem v-for="item in list1" :key="item.label" :label="item.label">
          <span v-if="item.value" class="mr-1">{{ item.value }}</span>
          <span v-if="item.button" class="text-primary c-p" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
        <image-viewer :list="[score_image]" :visible.sync="visible"/>
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <template v-if="diff_fee_tag.length">
          <ZuTips v-for="(item, idx) in diff_fee_tag" v-if="item.name" :key="idx" :type="item.type === 1 ? pay_status === 1 ? 'green' : 'red' : 'orange'" :value="item.name"/>
        </template>
      </div>
      <LineWrapper column="3" labelWidth="180rem" list>
        <LineItem v-for="item in list2" :key="item.label" :cssStyle="item.cssStyle" :label="item.label" :value="item.value" class="item"></LineItem>
      </LineWrapper>
      <template v-if="is_pay === '是'">
        <div class="table-wrap">
          <template v-if="is_by_stages===0">
            <zu-special-table :config="config1" :data="data1" isDetail></zu-special-table>
          </template>
          <template v-else-if="is_by_stages===1">
            <zu-installment-table :config="config1" :data="data1" isDetail></zu-installment-table>
          </template>
          <template v-else-if="is_by_stages===2">
            <zu-special-table :config="config1" :count="sum_first_price" :data="data1" is-part isDetail></zu-special-table>
          </template>
        </div>
        <LineWrapper column="3" labelWidth="180rem" list>
          <LineItem v-for="item in list3" :key="item.label" :cssStyle="item.cssStyle" :label="item.label" class="item">
            <span>{{ item.value }}</span>
            <div v-if="item.tips">
              <ZuTips v-for="child in item.tips" class="mt-2" show-icon type="red">{{ child }}</ZuTips>
            </div>
            <el-button v-if="item.status" :type="item.status" class="ml-1" size="mini">{{ item.status_name }}</el-button>
            <span v-if="item.button" class="text-primary ml-1 c-p" @click="handlePreview(item.type)">{{ item.button }}</span>
          </LineItem>
        </LineWrapper>
        <LineWrapper column="3" labelWidth="180rem" list>
          <LineItem label="实缴金额及方式">
            <div class="pay-info">
              <CustomTable :config="config2" :data="data2" type="gray"/>
              <div class="tips-info">
                <i class="el-icon-warning z-i"></i>
                <span>{{ sumAmount }}</span>
              </div>
            </div>
          </LineItem>
        </LineWrapper>

        <LineWrapper labelWidth="180rem">
          <LineItem v-for="item in list5" :key="item.label" :label="item.label" :value="item.value" label="备注"></LineItem>
        </LineWrapper>
      </template>
    </div>

    <div class="z-box-bg mb-2" v-if="isShowContract">
      <div class="z-box-title">
        <span class="z-box-title-text">协议签署</span>
      </div>
      <LineWrapper column="3" list>
        <LineItem :value="formData.is_need_sign_text" class="item" label="是否需要签约"></LineItem>
        <LineItem v-if="formData.status !== 3 && formData.is_need_sign_text !== '无需签约'" :value="formData.sign_status" class="item" label="签约状态"></LineItem>
      </LineWrapper>
      <LineWrapper v-if="formData.status !== 3 && formData.is_need_sign_text !== '无需签约'" column="1" list>
        <LineItem class="item" label="需签署合同">
          <el-tag v-for="i in formData.sign_contract" :key="i" style="margin-right: 12px" type="info">
            {{ i }}
          </el-tag>
        </LineItem>
      </LineWrapper>
    </div>

    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">操作记录</span>
      </div>
      <LineWrapper column="3" list>
        <LineItem v-for="item in list4" :key="item.label" :cssStyle="item.cssStyle" :label="item.label" :value="item.value" class="item"></LineItem>
      </LineWrapper>
    </div>
    <Dialog :showFooter="false" :title="title" :visible.sync="dialogVisible" size="large">
      <template v-if="dialogType === 1">
        <LineWrapper column="3" list>
          <LineItem v-for="item in dialogList" :key="item.label" :label="item.label" :value="item.value"></LineItem>
        </LineWrapper>
        <div class="pb-2"></div>
        <CustomTable :config="dialogListConfig1" :data="dialogListData1" :radius="false" headerBgColor="#CBE4FF" headerColor="#333" titleBgColor="#CBE4FF"></CustomTable>
        <CustomTable v-if="dialogListData2.length" :config="dialogListConfig2" :data="dialogListData2" :radius="false" headerBgColor="#CBE4FF" headerColor="#333" titleBgColor="#CBE4FF"></CustomTable>
      </template>
      <template v-else-if="dialogType === 2">
        <CustomTable :config="dialogConfig" :data="dialogData" border></CustomTable>
      </template>
      <template v-else-if="dialogType === 3">
        <div style="border-bottom: 1px dashed #598BFF;margin-bottom: 30rem;">
          <LineWrapper list min="280">
            <LineItem v-for="item in tableList4" :key="item.label" :label="item.label" :value="item.value">
            </LineItem>
          </LineWrapper>
        </div>
        <CustomTable :config="tableConfig4" :data="tableData4"/>
      </template>
    </Dialog>
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ImageViewer from '@/components/common/ImageViewer'
import Dialog from '@/components/common/Dialog'
import ZuSpecialTable from "./components/ZuSpecialTable"
import ZuInstallmentTable from "./components/ZuInstallmentTable"
import CustomTable from "@/components/common/CustomTable"
import ZuTips from "@/components/common/ZuTips"
import http from '@/api'
import { formatDate, preciseAdd, preciseSubtract } from '@/utils'

export default {
  _config: {"route": {"path": "look", "meta": {"title": "查看"}}},
  components: {LineWrapper, LineItem, ImageViewer, Dialog, CustomTable, ZuSpecialTable, ZuInstallmentTable, ZuTips},
  data() {
    return {
      loading: false,
      visible: false,
      dialogVisible: false,
      isShowContract: false,
      sum_first_price: 0,
      is_pay: '',
      student_name: '',
      title: '',
      is_by_stages: '',
      dialogType: '',
      dialogList: [],
      dialogListData1: [],
      dialogListData2: [],
      dialogListConfig1: [],
      dialogListConfig2: [],
      dialogData: [],
      dialogConfig: [],
      tableData4: [],
      tableConfig4: [],
      tableList4: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      data1: [],
      config1: [],
      data2: [],
      config2: [],
      sumAmount: 0,
      score_image: '',
      pay_status: '',
      diff_fee_tag: [],
      formData: {}
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handlePreview(type) {
      if (type === 0) {
        this.visible = true
      } else {
        this.dialogVisible = true
        const arr = {
          1: '最高诊断性考试成绩详情',
          2: '预报名订单',
          3: `${this.student_name}的缴费计划`
        }
        this.title = arr[type]
        this.dialogType = type
      }
    },
    getData() {
      this.loading = true
      http({url: '/recruit-v2/order-offline/show?id=' + this.$route.query.id, pre: 'zs'}).then(res => {
        this.isShowContract = res.year < 2026
        this.is_by_stages = res.is_by_stages
        this.formData = res
        http({url: '/recruit-v2/order-offline/get-goods-stages', pre: 'zs'}, {order_id: res.order_id, is_by_stages: res.is_by_stages}).then(res2 => {
          this.is_pay = res.is_pay
          this.student_name = res.student_name
          this.score_image = res.score_image
          this.pay_status = res.pay_status
          this.diff_fee_tag = res.tag || []
          // 基础信息
          const list1 = [
            {label: '订单编号', value: res.order_number},
            {label: '入账学校', value: res.school},
            {label: '购买服务名称', value: res.goods_pack_name},

            {label: '学生姓名', value: res.student_name},
            {label: '学生身份证号/护照号', value: res.student_idcard},
            {label: '报名年级', value: res.grade_name},
            {label: '学习方向', value: res.study_type_name || '-'},
            {label: '专业方向', value: res.major_name || '-'},

            {label: '当前客户归属招生老师', value: res.belong_teacher}
          ]
          list1.push({label: '是否参与预报名', value: res.is_pre_register, button: res.is_pre_register === '是' ? '查看详情' : '', type: 2})
          if (res.is_pre_register === '是') {
            list1.push({label: '预报名支付金额', value: res.pre_register_amount})
          }
          if (res.order_type === 2) {
            if (res.max_score_name === '中考') {
              list1.push({label: '中考成绩折算后总分', value: res.max_score})
              list1.push({label: '中考成绩截图', value: res.score_image ? '' : '-', button: res.score_image ? '查看成绩截图' : '', type: 0})
            } else {
              list1.push({label: '最高诊断性考试折算后总分', value: res.max_score, button: '查看详情', type: 1})
              this.dialogList = [
                {label: '学生姓名', value: res.student_name},
                {label: '学生参考城市', value: res.senior_city},
                {label: '考试名称', value: res.max_score_name},
                {label: '考试总分', value: res.junior_score},
                {label: '折算后考试总分', value: res.max_score}
              ]
              const {diagnose_score_list} = res
              const options = [], l1 = diagnose_score_list[0]?.length
              if (l1) {
                for (let i = 0; i < l1; i++) {
                  options.push({label: diagnose_score_list[0][i], value: diagnose_score_list[1][i]})
                }
              }
              let l2 = options.length
              if (l2 > 3) {
                l2 = Math.ceil(l2 / 2)
              }
              const obj1 = {num: '分数'}, obj2 = {num: '分数'}, config1 = [{label: '科目', prop: 'num', type: 'title'}], config2 = [{label: '科目', prop: 'num', type: 'title'}]
              options.forEach((i, index) => {
                if (index < l2) {
                  obj1[`k_${index}`] = i.value
                  config1.push({prop: `k_${index}`, label: i.label})
                } else {
                  obj2[`k_${index}`] = i.value
                  config2.push({prop: `k_${index}`, label: i.label})
                }
              })
              this.dialogListData1 = [obj1]
              this.dialogListConfig1 = config1
              if (config2.length > 1) {
                const l3 = config1.length - config2.length
                if (l3 > 0) {
                  for (let i = 0; i < l3; i++) {
                    config2.push({prop: `z_${i}`, label: ''})
                  }
                }
                this.dialogListData2 = [obj2]
                this.dialogListConfig2 = config2
              }
            }
          }
          this.list1 = list1
          // 缴费详情
          const {payment_detail = []} = res2
          const list2 = [
            {label: '系统计算应缴总额', value: res.money_answer}
          ]
          const list5 = []
          const hasVal = payment_detail.some(i => i.payment_method === '银行垫资')
          if (hasVal) {
            list5.push({label: '三年学费预计应缴总额', value: res2.senior_all_cost})
          }
          if (res.reason) {
            list5.push({label: '备注', value: res.reason})
          }

          // 操作记录
          const list3 = []
          if (res.is_pay === '是') {
            const s1 = Number(res2.sum_price) || 0
            const s2 = Number(res2.interest_amount_total) || 0
            const s3 = Number(res2.sum_first_price) || 0

            const arr = ['否', '是', '部分欠缴']
            list2.push({label: '是否缴费', value: res.is_pay})
            list2.push({label: '是否分期', value: arr[res.is_by_stages]})
            const obj = {
              label: res.is_by_stages ? '合计实际应缴总额' : '合计实缴总额',
              value: s1
            }
            if (s2) {
              const v = preciseSubtract(s1, s2)
              obj.value = v
              if (!res.is_by_stages) {
                obj.tips = [`学生合计应缴总额：${s1}`, `累计利息减免总额：${s2}`]
              }
            }
            list3.push(obj)
            list3.push({label: '合计特批优惠总额', value: res2.sum_discount_price, cssStyle: {'grid-column': '2 / -1'}})
            if (res.is_by_stages) {
              this.sum_first_price = res2.sum_first_price
              const obj = {
                label: '合计本期实缴总额',
                value: s3
              }
              if (s2 && res.is_by_stages) {
                const v = preciseSubtract(s3, s2)
                obj.value = v
                obj.tips = [`学生合计本期应缴总额：${s3}`, `累计利息减免总额：${s2}`]
              }
              list3.push(obj)
              list3.push({label: '合计本期欠缴总额', value: res2.sum_remain_price, button: res.stages_detail?.length ? '查看缴费计划' : '', type: 3, cssStyle: {'grid-column': '2 / -1'}})
            }
            // list3.push({label: '缴费时间', value: res.payment_at})
            const statusMap = ['无需审批', '审批中', '已通过', '已驳回']
            const colorMap = ['info', 'warning', 'success', 'danger']
            const s_name = statusMap[res.stages_dingtalk_approve_status]
            const s_color = colorMap[res.stages_dingtalk_approve_status]
            const d_name = statusMap[res.discount_dingtalk_approve_status]
            const d_color = colorMap[res.discount_dingtalk_approve_status]
            if (res.is_by_stages) {
              const obj1 = {label: '是否发起分期钉钉审批', value: res.is_stages_dingtalk_approve ? '是' : '否'}
              if (res.is_stages_dingtalk_approve) {
                obj1.status = s_color
                obj1.status_name = s_name
              }
              list3.push(obj1)
            }
            if (Number(res2.sum_discount_price)) {
              const obj2 = {label: '是否发起特批优惠钉钉审批', value: res.is_discount_dingtalk_approve ? '是' : '否'}
              if (res.is_discount_dingtalk_approve) {
                obj2.status = d_color
                obj2.status_name = d_name
              }
              list3.push(obj2)
              if (res.is_discount_dingtalk_approve) {
                list3.push({label: '特批优惠减免类型', value: res.discount_amount_type === 1 ? '政策内减免' : '政策外减免'})
              }
            }
          } else {
            list2.push({label: '是否缴费', value: res.is_pay, cssStyle: {'grid-column': '2 / -1'}})
            list2.push({label: '驳回原因', value: res.reason, cssStyle: {'grid-column': '1 / 3'}})
          }
          this.list2 = list2
          this.list3 = list3
          this.list5 = list5

          const {pre_register = [], stages_detail = []} = res
          // 预报名订单
          this.dialogData = pre_register.map(i => ({
            order_number: i.order_number,
            belong_teacher_name: i.belong_teacher_name,
            money_answer: i.money_answer,
            money_actual: i.money_actual,
            pay_time: i.pay_time || '-'
          }))
          this.dialogConfig = [
            {prop: 'order_number', label: '预报名订单号'},
            {prop: 'belong_teacher_name', label: '预报名客户归属人'},
            {prop: 'money_answer', label: '应缴金额'},
            {prop: 'money_actual', label: '实缴金额'},
            {prop: 'pay_time', label: '支付时间'}
          ]
          // 实缴金额及方式 利息减免金额：{{ domain.interest_amount }}
          if (!(payment_detail.length === 1 && Number(payment_detail[0].paid_amount) === 0)) {
            this.data2 = payment_detail.map(i => {
              return {
                paid_amount: i.interest_amount ? `${i.paid_amount}(利息减免金额：${i.interest_amount})` : i.paid_amount,
                payment_method: i.payment_method,
                payer: i.payer,
                payment_at: i.payment_at
              }
            })
            this.config2 = [
              {prop: 'paid_amount', label: '学生缴费金额', type: 'other'},
              {prop: 'payment_method', label: '学生缴费方式', type: 'other'},
              {prop: 'payer', label: '付款人姓名', type: 'other'},
              { prop: 'payment_at', label: '缴费时间', type: 'other' }
            ]
            const sum = payment_detail.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
            this.sumAmount = `累计实缴金额：${sum}`
          }
          // 操作记录
          this.list4 = [
            {label: '操作人', value: res.approval_creator},
            {label: '操作时间', value: res.approval_at, cssStyle: {'grid-column': '2 / -1'}},
          ]
          // 分期表单
          const {goods_stages} = res2
          let obj2 = {1: '享受当年优惠', 2: '享受两年优惠', 3: '享受三年优惠'}
          const list = goods_stages.map((i) => {
            const {stages_mode_select, ...j} = i
            let obj = {}
            if (stages_mode_select.length) {
              stages_mode_select.map((k) => {
                obj[Object.keys(k)[0]] = Object.values(k)[0]
              })
            }
            return {
              ...j,
              stages_mode: obj[i.stages_mode] || '',
              discount_year: obj2[i.discount_year] || ''
            }
          })
          this.data1 = list
          if (res.is_by_stages === 1) {
            this.config1 = [
              {label: '序号', type: 'index'},
              {prop: 'goods_category_name', label: '学费明细', type: 'text'},
              {prop: 'stages_mode', label: '缴费计划', type: 'text'},
              {prop: 'compute_price', label: '系统计算应缴金额', type: 'text'},
              {prop: 'discount_price', label: '特批优惠金额', type: 'text'},
              {prop: 'discount_year', label: '特批优惠年份', type: 'text'},
              {prop: 'price', label: '实际应缴金额', type: 'text'},
              {prop: 'first_price', label: '本期实缴金额', type: 'text'},
              {prop: 'average_price', label: '每期应缴金额', type: 'text'}
            ]
          } else {
            this.config1 = [
              {label: '', type: 'title'},
              {prop: 'compute_price', label: '系统计算应缴金额', type: 'text'},
              {prop: 'discount_price', label: '特批优惠金额', type: 'text'},
              {prop: 'discount_year', label: '特批优惠年份', key: 'discount_year', type: 'text'}
            ]
          }
          // 缴费计划
          const cf = [
            {prop: 'left', label: ['缴费状态', '缴费计划'], type: 'custom'}
          ]
          stages_detail[0].forEach((i, j) => {
            cf.push({prop: 'period' + j, label: i, type: 'other'})
          })
          cf.push({prop: 'compute_price', label: '合计', type: 'other'})
          const len = stages_detail[0].length
          const arr1 = stages_detail[1].map(i => {
            let obj = {left: i.goods_category_name_show}
            for (let j = 0; j < len; j++) {
              obj['period' + j] = i.child[j]?.answer_price || '-'
            }
            obj.compute_price = i.total
            return obj
          })
          const arr0 = [{label: '已缴金额'}, {label: '合计欠缴'}]
          const arr2 = arr0.map((i, j) => {
            const obj = {}
            stages_detail[2].map((k, l) => {
              obj['period' + l] = j ? k.have_not_paid : k.total_price
            })
            if (j) {
              obj.compute_price = res.stages_money_not_paid
            } else {
              obj.compute_price = res.total_price
            }
            return {left: i.label, ...obj}
          })
          this.tableConfig4 = cf
          this.tableData4 = [...arr1, ...arr2]
          this.tableList4 = [
            {label: '实际应缴总额', value: res.stages_money_answer},
            {label: '实际支付总额', value: res.stages_money_actual},
            {label: '欠缴总额', value: res.stages_money_not_paid}
          ]
          if (res.is_by_stages === 1) {
            this.tableList4.splice(1, 0, {label: '一期实缴金额', value: res.stages_first_money_actual},)
          }
        }).finally(() => {
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-info {
  margin-top: 10rem;
  padding: 0 10rem;
  background-color: #f4f4f5;
  color: #909399;
  font-size: 12rem;
  line-height: 30rem;
  display: inline-block;
  border-radius: 6rem;

  .z-i {
    margin-right: 4rem;
  }

  &.warning {
    color: #F25858;
    background-color: #FFEAEA;
  }
}

.pay-info {
  width: 700rem;
}

.table-wrap {
  padding: 30rem 0;
  margin: 30rem 0;
  border-top: dashed 1rem #598BFF;
  border-bottom: dashed 1rem #598BFF;
}
</style>
